// extracted by mini-css-extract-plugin
module.exports = {"tableContainerMobile":"mobileTable_tableContainerMobile__1QHvt","tableItem":"mobileTable_tableItem__3Wwks","tableRow":"mobileTable_tableRow__8qBz6"};